/* Decode a JWT token */
export const decodeToken = (token: string): Record<string, any> | undefined => {
  const payload = token.split('.')[1]

  if (payload) {
    try {
      const decoded = atob(payload)

      return JSON.parse(decoded)
    } catch (e) {
      console.log(e)

      return
    }
  }

  return
}

export const getTokenRemainingTimeToExpireInMs = (token: string) => {
  const decodedToken = decodeToken(token)

  const now = Date.now()
  const tokenExpiresAtInMs = decodedToken.exp * 1000
  const timeRemainingInMs = tokenExpiresAtInMs - now

  return timeRemainingInMs
}

/* Check if a token is valid. Will return false if the token can't be decoded
 * or if it's expired.
 */
export const isTokenValid = (token: string): boolean => {
  const decodedToken = decodeToken(token)
  const now = Date.now()

  if (!decodedToken) {
    return false
  }

  const exp = decodedToken.exp as number

  return exp * 1000 >= now
}


export const isPartial = (token: string): boolean => {
  const decodedToken = decodeToken(token)

  if (!decodedToken) {
    return false
  }

  return decodedToken?.partial
}